import {
  Avatar,
  Table,
  Pagination,
  Flex,
  Badge,
  Popover,
  Input,
} from "@mantine/core";
import { useEffect, useState } from "react";
import { useParams } from "react-router";
import { getEmployeeList } from "../../api/employeeApi";
import styled from "styled-components";

const EmployeeTable = () => {

  const [tableData, setTableData] = useState<any>();
  //for pagination
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(5);
  const [totalPages, setTotalPages] = useState(1);

  //for department select
  //for sort
  const [sort, setSort] = useState<any>("");
  //for search
  const [searchedName, setSearchedName] = useState<any>();
  const { id } = useParams(); 
  // for create
  const getTableData = async () => {
    try {
      const { data }: any = await getEmployeeList({
        companyId: id,
        pageNumber: page,
        limit: limit,
        sort,
        name: searchedName,
      });
      setTableData(data?.data);
      setPage(data?.meta?.page);
      setLimit(data?.meta?.limit);
      setTotalPages(data?.meta?.totalPages);
    } catch (error) {}
  };

  useEffect(() => {
    if (page) {
      getTableData();
    }
  }, [page, sort, searchedName]);



  return (
    <TableWrapper>
      <div style={{ overflowX: "auto", width: "100%" }}>
          <Table
            style={{
              borderCollapse: "separate",
              borderSpacing: "0px 4px",
            }}
            highlightOnHover
            verticalSpacing="sm"
            withRowBorders={false}
          >
            <Table.Thead>
              <Table.Tr>
                <StyledTableTh style={{ width: "25%" }}>
                  <Flex gap={4}>
                    <Flex
                      gap={4}
                      style={{
                        cursor: "pointer",
                        alignItems: "center",
                      }}
                      onClick={() => {
                        setSort((prev: string) =>
                          prev === "desc" ? "asc" : "desc"
                        );
                      }}
                    >
                      <div>Ad Soyad</div>
                      {sort === "desc" ? (
                        <Avatar src={"/assets/ascSortIcon.png"} size={16} />
                      ) : (
                        <Avatar src={"/assets/descSortIcon.png"} size={16} />
                      )}
                    </Flex>
                    <Popover position="right" shadow="md">
                      <Popover.Target>
                        <div style={{ width: "max-content" }}>
                          <Avatar
                            style={{
                              cursor: "pointer",
                            }}
                            src={"/assets/searchIcon.png"}
                            size={16}
                          />
                        </div>
                      </Popover.Target>
                      <Popover.Dropdown>
                        <Input
                          value={searchedName}
                          onChange={(event) => {
                            {
                              setPage(1);
                              setSearchedName(event.currentTarget.value);
                            }
                          }}
                        />
                      </Popover.Dropdown>
                    </Popover>
                  </Flex>
                </StyledTableTh>
                <StyledTableTh style={{ width: "15%" }}>Telefon</StyledTableTh>
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
              {tableData?.map((employee: any) => (
                <Table.Tr
                  bg={"#F9F9F9"}
                  key={employee?._id}
                  style={{
                    color: "#1D1B20",
                    fontSize: "16px",
                    fontWeight: "400",
                  }}
                >
                  <Table.Td style={{ width: "25%" }}>
                    <Flex justify={"start"} align={"center"} gap={16}>
                      <Badge
                        style={{ minWidth: "40px" }}
                        circle
                        bg={"#EADDFF"}
                        size={"40px"}
                      >
                        <AvatarText>{employee?.name[0]}</AvatarText>
                      </Badge>
                      {employee?.name}
                    </Flex>
                  </Table.Td>
                  <Table.Td
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      width: "15%",
                    }}
                  >
                    {employee?.phone}
                  </Table.Td>
                </Table.Tr>
              ))}
            </Table.Tbody>
          </Table>
      </div>
      <Flex justify="center" mt="md" pb="sm">
        <Pagination
          total={totalPages}
          value={page}
          onChange={setPage}
          withEdges
          color="#5C26FF"
          radius="xl"
        />
      </Flex>
    </TableWrapper>
  );
};

export default EmployeeTable;

const StyledTableTh = styled(Table.Td)`
  color: #4c4c4c;
  font-size: 14px;
  font-weight: 600;
  line-height: 16px;
`;

const AvatarText = styled.div`
  color: #21005d;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.15000000596046448px;
`;

const TableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1;
  justify-content: space-between;
`;